var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4FCECA6C-E566-48A6-946D-688189B91A6C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Sucesso-/-Modal-/-Web",
    transform: "translate(-22.000000, -26.000000)",
    fill: "#E71037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick",
    transform: "translate(22.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,0 C11.1928867,0 0,11.1928867 0,25 C0,38.8071133 11.1928867,50 25,50 C38.8071133,50 50,38.8071133 50,25 C49.9853515,11.19906 38.8010446,0.0147530898 25,0 Z M25,46.4286013 C13.1653016,46.4286013 3.57139868,36.8346984 3.57139868,25 C3.57139868,13.1653016 13.1653016,3.57139868 25,3.57139868 C36.8346984,3.57139868 46.4286013,13.1653016 46.4286013,25 C46.4158362,36.8294668 36.8294668,46.4158362 25,46.4286013 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4466282,15.4917779 C37.7442137,14.836074 36.6306945,14.836074 35.9283862,15.4917779 L19.0847751,31.7714644 L13.1161634,26.0026456 C12.4207582,25.3067044 11.2732546,25.2875095 10.5533169,25.9596368 C9.83327298,26.6317641 9.81341336,27.7408562 10.5088186,28.4366948 C10.5233682,28.4512706 10.5382363,28.465641 10.5533169,28.4797035 L17.8033518,35.4870513 C18.5110764,36.1709829 19.6584738,36.1709829 20.3661984,35.4870513 L38.4912327,17.9687332 C39.1866379,17.2728947 39.1666721,16.1639052 38.4466282,15.4917779 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.ca54270d05f84f2361b1783c4f4e2c7f.svg";
export { ForwardRef as ReactComponent };